// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___262fA","container_1":"container_1___3wMce","container_2":"container_2___2T8pV","hour-24-tag":"hour-24-tag___25vWi"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/stores/styles.module.scss
// module id = 130
// module chunks = 0